/**
 * BY_TOPICS catalog images — static lookup by templateKey only.
 * Groups: topic JPEG. Tests: difficulty.soft|medium|hard.jpg.
 * Not linked to catalogImageConfigByDifficulties.v1.ts at runtime.
 *
 * Docs: docs/docsForUI/CATALOG_STATIC_IMAGES_V1.md
 */
export type CatalogStaticImageRef = {
  imageStoragePath: string;
  imageUrl: string;
};

const SOFT_TEST_IMAGE: CatalogStaticImageRef = {
  imageStoragePath: 'images/catalog/difficulty.soft.jpg',
  imageUrl:
    'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdifficulty.soft.jpg?alt=media&token=348d2f79-cd10-4012-a8d0-245754933f6d',
};

const MEDIUM_TEST_IMAGE: CatalogStaticImageRef = {
  imageStoragePath: 'images/catalog/difficulty.medium.jpg',
  imageUrl:
    'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdifficulty.medium.jpg?alt=media&token=083bb717-3ab5-42f5-8378-b3861f937bb6',
};

const HARD_TEST_IMAGE: CatalogStaticImageRef = {
  imageStoragePath: 'images/catalog/difficulty.hard.jpg',
  imageUrl:
    'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdifficulty.hard.jpg?alt=media&token=5c52f886-54a8-4b51-9b29-89b48c40cb8e',
};

/** BY_TOPICS parent covers: topic image (first topic image, no indexing in the group title). */
export const BY_TOPICS_GROUP_IMAGE_CONFIG_V1: Record<string, CatalogStaticImageRef> = {
  'topic.priority-on-road': {
    imageStoragePath: 'images/catalog/priority-on-road-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fpriority-on-road-1.jpg?alt=media&token=d42d945c-02ff-4c7a-b526-1501707dd401',
  },
  'topic.sharing-road': {
    imageStoragePath: 'images/catalog/sharing-road-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fsharing-road-1.jpg?alt=media&token=6ca1fae4-4627-4d01-8a22-19d07999ea5b',
  },
  'topic.sharing-pedestrians': {
    imageStoragePath: 'images/catalog/sharing-pedestrians-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fsharing-pedestrians-1.jpg?alt=media&token=edd39ad7-5147-42e1-b2dd-1007a9c1e424',
  },
  'topic.sharing-school-bus': {
    imageStoragePath: 'images/catalog/sharing-school-bus-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fsharing-school-bus-1.jpg?alt=media&token=6b3962b0-6d35-461b-938f-cbd64bd3cdf7',
  },
  'topic.maneuvers-signaling': {
    imageStoragePath: 'images/catalog/maneuvers-signaling-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fmaneuvers-signaling-1.jpg?alt=media&token=14ffeb48-8762-4f24-8b51-bd67756c33ad',
  },
  'topic.passing': {
    imageStoragePath: 'images/catalog/passing-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fpassing-1.jpg?alt=media&token=d7c299dc-c8c9-456f-828a-cd4a6cb44125',
  },
  'topic.parking-regulations': {
    imageStoragePath: 'images/catalog/parking-regulations-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fparking-regulations-1.jpg?alt=media&token=9b18ddcb-377f-4d01-a591-f594f9f9e3ea',
  },
  'topic.road-signs': {
    imageStoragePath: 'images/catalog/road-signs-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-signs-1.jpg?alt=media&token=3ca7b20b-e08f-4521-bfe0-1807eb84746c',
  },
  'topic.road-markings': {
    imageStoragePath: 'images/catalog/road-markings-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-markings-1.jpg?alt=media&token=9f9a3a80-ceb7-4811-a6a4-ac5dd4fc9ece',
  },
  'topic.roundabouts': {
    imageStoragePath: 'images/catalog/roundabouts-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froundabouts-2.jpg?alt=media&token=70f11ff6-739d-418a-8ace-0635b941d3cd',
  },
  'topic.use-of-lights': {
    imageStoragePath: 'images/catalog/use-of-lights-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fuse-of-lights-2.jpg?alt=media&token=5e6c8c6c-9225-47f0-a4fe-04cc017b92ec',
  },
  'topic.braking': {
    imageStoragePath: 'images/catalog/braking-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fbraking-1.jpg?alt=media&token=a15173af-47dd-4ef3-a703-696ab809d0e2',
  },
  'topic.railroad-crossings': {
    imageStoragePath: 'images/catalog/railroad-crossings-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Frailroad-crossings-2.jpg?alt=media&token=bf140e94-fe38-447d-bd3b-ae7c11433f4b',
  },
  'topic.traffic-regulations': {
    imageStoragePath: 'images/catalog/traffic-regulations-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Ftraffic-regulations-1.jpg?alt=media&token=2deb0040-3685-4cbd-b388-c8185669bd85',
  },
  'topic.fines-and-limits': {
    imageStoragePath: 'images/catalog/fines-and-limits-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Ffines-and-limits-1.jpg?alt=media&token=ba3c0eec-4c2a-4cf1-9d15-4b4c5d253b5d',
  },
  'topic.freeways': {
    imageStoragePath: 'images/catalog/freeways-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Ffreeways-1.jpg?alt=media&token=acf99eaa-b711-4254-8ec2-a7a719970601',
  },
  'topic.emergency-on-road': {
    imageStoragePath: 'images/catalog/emergency-on-road-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Femergency-on-road-1.jpg?alt=media&token=b00f953d-730a-4268-b491-98eaf1feb747',
  },
  'topic.road-work': {
    imageStoragePath: 'images/catalog/road-work-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-work-1.jpg?alt=media&token=12dbdfe9-3c88-4310-9224-a728a822542e',
  },
  'topic.weather-conditions': {
    imageStoragePath: 'images/catalog/weather-conditions-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fweather-conditions-1.jpg?alt=media&token=6e2ef2ad-1292-47db-8637-dce7631b75e7',
  },
  'topic.drinking-driving': {
    imageStoragePath: 'images/catalog/drinking-driving-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdrinking-driving-1.jpg?alt=media&token=3a1bb696-fdb6-4e08-adf4-5e43de3dbb19',
  },
  'topic.driving': {
    imageStoragePath: 'images/catalog/driving-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdriving-1.jpg?alt=media&token=301a0086-72d7-4e34-8411-1302a43c0f6e',
  },
  'topic.driver-license': {
    imageStoragePath: 'images/catalog/driver-license-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdriver-license-2.jpg?alt=media&token=d58efbdf-99b0-44c8-a513-89e6d3ed82d1',
  },
};

/** BY_TOPICS child tests: difficulty cover per row (Soft / Medium / Hard). */
export const BY_TOPICS_TEST_IMAGE_CONFIG_V1: Record<string, CatalogStaticImageRef> = {
  'topic.priority-on-road.difficulty.soft.slot.1': SOFT_TEST_IMAGE,
  'topic.sharing-pedestrians.difficulty.soft.slot.1': SOFT_TEST_IMAGE,
  'topic.sharing-road.difficulty.soft.slot.1': SOFT_TEST_IMAGE,
  'topic.maneuvers-signaling.difficulty.soft.slot.1': SOFT_TEST_IMAGE,
  'topic.passing.difficulty.soft.slot.1': SOFT_TEST_IMAGE,
  'topic.parking-regulations.difficulty.soft.slot.1': SOFT_TEST_IMAGE,
  'topic.road-signs.difficulty.soft.slot.1': SOFT_TEST_IMAGE,
  'topic.road-markings.difficulty.soft.slot.1': SOFT_TEST_IMAGE,
  'topic.braking.difficulty.soft.slot.1': SOFT_TEST_IMAGE,
  'topic.traffic-regulations.difficulty.soft.slot.1': SOFT_TEST_IMAGE,
  'topic.driving.difficulty.soft.slot.1': SOFT_TEST_IMAGE,
  'topic.road-signs.difficulty.soft.slot.2': SOFT_TEST_IMAGE,
  'topic.traffic-regulations.difficulty.soft.slot.2': SOFT_TEST_IMAGE,

  'topic.priority-on-road.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.sharing-school-bus.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.sharing-road.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.maneuvers-signaling.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.passing.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.parking-regulations.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.road-signs.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.road-markings.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.roundabouts.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.use-of-lights.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.braking.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.railroad-crossings.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.traffic-regulations.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.freeways.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.emergency-on-road.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.road-work.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.weather-conditions.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.drinking-driving.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.driving.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.driver-license.difficulty.medium.slot.1': MEDIUM_TEST_IMAGE,
  'topic.road-signs.difficulty.medium.slot.2': MEDIUM_TEST_IMAGE,
  'topic.traffic-regulations.difficulty.medium.slot.2': MEDIUM_TEST_IMAGE,
  'topic.driving.difficulty.medium.slot.2': MEDIUM_TEST_IMAGE,

  'topic.sharing-road.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.sharing-road.difficulty.hard.slot.2': HARD_TEST_IMAGE,
  'topic.road-signs.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.roundabouts.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.use-of-lights.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.railroad-crossings.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.traffic-regulations.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.fines-and-limits.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.freeways.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.emergency-on-road.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.road-work.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.weather-conditions.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.drinking-driving.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.driving.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.driver-license.difficulty.hard.slot.1': HARD_TEST_IMAGE,
  'topic.road-signs.difficulty.hard.slot.2': HARD_TEST_IMAGE,
};

export const BY_TOPICS_CROSS_BAND_IMAGE_CONFIG_V1: Record<string, CatalogStaticImageRef> = {
  'topic.priority-on-road.difficulty.soft': SOFT_TEST_IMAGE,
  'topic.sharing-pedestrians.difficulty.soft': SOFT_TEST_IMAGE,
  'topic.sharing-road.difficulty.soft': SOFT_TEST_IMAGE,
  'topic.maneuvers-signaling.difficulty.soft': SOFT_TEST_IMAGE,
  'topic.passing.difficulty.soft': SOFT_TEST_IMAGE,
  'topic.parking-regulations.difficulty.soft': SOFT_TEST_IMAGE,
  'topic.road-signs.difficulty.soft': SOFT_TEST_IMAGE,
  'topic.road-markings.difficulty.soft': SOFT_TEST_IMAGE,
  'topic.braking.difficulty.soft': SOFT_TEST_IMAGE,
  'topic.traffic-regulations.difficulty.soft': SOFT_TEST_IMAGE,
  'topic.driving.difficulty.soft': SOFT_TEST_IMAGE,
  'topic.priority-on-road.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.sharing-school-bus.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.sharing-road.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.maneuvers-signaling.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.passing.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.parking-regulations.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.road-signs.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.road-markings.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.roundabouts.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.use-of-lights.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.braking.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.railroad-crossings.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.traffic-regulations.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.freeways.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.emergency-on-road.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.road-work.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.weather-conditions.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.drinking-driving.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.driving.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.driver-license.difficulty.medium': MEDIUM_TEST_IMAGE,
  'topic.sharing-road.difficulty.hard': HARD_TEST_IMAGE,
  'topic.road-signs.difficulty.hard': HARD_TEST_IMAGE,
  'topic.roundabouts.difficulty.hard': HARD_TEST_IMAGE,
  'topic.use-of-lights.difficulty.hard': HARD_TEST_IMAGE,
  'topic.railroad-crossings.difficulty.hard': HARD_TEST_IMAGE,
  'topic.traffic-regulations.difficulty.hard': HARD_TEST_IMAGE,
  'topic.fines-and-limits.difficulty.hard': HARD_TEST_IMAGE,
  'topic.freeways.difficulty.hard': HARD_TEST_IMAGE,
  'topic.emergency-on-road.difficulty.hard': HARD_TEST_IMAGE,
  'topic.road-work.difficulty.hard': HARD_TEST_IMAGE,
  'topic.weather-conditions.difficulty.hard': HARD_TEST_IMAGE,
  'topic.drinking-driving.difficulty.hard': HARD_TEST_IMAGE,
  'topic.driving.difficulty.hard': HARD_TEST_IMAGE,
  'topic.driver-license.difficulty.hard': HARD_TEST_IMAGE,
};

/** All BY_TOPICS test-level images (slotted + cross-band difficulty rows). */
export const BY_TOPICS_ALL_TEST_IMAGE_CONFIG_V1: Record<string, CatalogStaticImageRef> = {
  ...BY_TOPICS_TEST_IMAGE_CONFIG_V1,
  ...BY_TOPICS_CROSS_BAND_IMAGE_CONFIG_V1,
};
